import { Api } from '@pharmac-extranet/extranet-api'
import type Keycloak from 'keycloak-js'

const { VITE_API_URL, VITE_TOKEN_TTL_MINUTES } = import.meta.env
export const api = new Api({ baseURL: VITE_API_URL })

const configure = (keycloak: Keycloak) => {
  api.instance.interceptors.request.use(async (config) => {
    if (config?.headers) {
      config.headers['Content-Type'] = 'application/json'
    }

    if (keycloak.authenticated) {
      await keycloak.updateToken((VITE_TOKEN_TTL_MINUTES ?? 20) * 60 * 1000)

      if (config && config.headers) {
        config.headers.Authorization = `Bearer ${keycloak.token}`
      }

      return Promise.resolve(config)
    }

    return config
  })
}

const unconfigure = () => {
  api.instance.interceptors.request.use(async (config) => {
    config.headers.Authorization = undefined
    return config
  })
}

const getAxiosClient = () => api.instance

const HttpService = {
  configure,
  unconfigure,
  getAxiosClient,
}

export default HttpService
